
import { Component, Vue} from 'vue-property-decorator';
import GetHelpScanning from "./GetHelpScanning.vue";

@Component({
    components:{        
        GetHelpScanning,
    }
}) 
export default class UploadDocumentHeader extends Vue {

    showGetHelpScanning = false;

}
